import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import styled from 'styled-components';
import { ChevronLeftIcon, ChevronRightIcon } from '@origin-digital/icon';
import { enhanceWithTrackable } from '../hocs';
import { FontSizes } from '../../consts';
import { linkChevronPropTypes, LinkColor, linkPropTypes, linkTextPropTypes } from './Link.types';
import { fontSize, sansSerif } from '../../helpers';

var LinkUntracked = function LinkUntracked(props) {
  var children = props.children,
      href = props.href,
      onClick = props.onClick,
      size = props.size,
      componentType = props.componentType,
      rest = __rest(props, ["children", "href", "onClick", "size", "componentType"]); // @ts-ignore FIXME: until we deprecate tracking


  var tracking = props.tracking;
  var clickHandler = href && onClick ? function (e) {
    e.preventDefault();
    return onClick(e);
  } : onClick;
  return React.createElement("a", _extends({}, rest, {
    href: href,
    onClick: onClick && clickHandler
  }), children);
};

var Link = enhanceWithTrackable(LinkUntracked);
Link.propTypes = linkPropTypes;
var linkDisplayName = 'link';
var linkTextDefaultProps = {
  color: 'dark',
  'data-id': linkDisplayName,
  hoverColor: 'red',
  size: 'sm'
};
var LinkText = enhanceWithTrackable(styled(function (props) {
  // @ts-ignore
  var text = props.text,
      hoverColor = props.hoverColor,
      color = props.color,
      restProps = __rest(props, ["text", "hoverColor", "color"]);

  return React.createElement(LinkUntracked, restProps, text);
}).withConfig({
  displayName: "Link__LinkText",
  componentId: "z1wi2f-0"
})(["color:", ";", ";", " &:hover{color:", ";text-decoration:none;}&:hover > svg{fill:", ";}"], function (_ref) {
  var color = _ref.color;
  return LinkColor[color];
}, sansSerif, fontSize, function (_ref2) {
  var hoverColor = _ref2.hoverColor;
  return LinkColor[hoverColor];
}, function (_ref3) {
  var hoverColor = _ref3.hoverColor;
  return LinkColor[hoverColor];
}));
LinkText.propTypes = linkTextPropTypes;
LinkText.displayName = 'linkText';
LinkText.defaultProps = linkTextDefaultProps;
var linkChevronDisplayName = 'linkChevron';
var linkChevronDefaultProps = {
  color: 'red',
  'data-id': linkChevronDisplayName,
  direction: 'right'
};
var LinkChevron = enhanceWithTrackable(styled(function (props) {
  var text = props.text,
      direction = props.direction,
      restProps = __rest(props, ["text", "direction"]);

  var Icon = direction === 'right' ? ChevronRightIcon : ChevronLeftIcon;
  return React.createElement(LinkUntracked, restProps, React.createElement(Icon, {
    accessibilityLabel: "chevron",
    size: 21
  }), React.createElement("span", null, text));
}).withConfig({
  displayName: "Link__LinkChevron",
  componentId: "z1wi2f-1"
})(["color:", ";text-decoration:none;display:flex;> span{color:", ";font-size:", "px;", ";}> svg{fill:", ";flex:0 0 21px;}&:hover{> svg{margin-left:4px;}> span{margin-left:-4px;}}"], function (_ref4) {
  var color = _ref4.color;
  return LinkColor[color];
}, function (_ref5) {
  var color = _ref5.color;
  return LinkColor[color];
}, FontSizes.BODY, sansSerif, function (_ref6) {
  var color = _ref6.color;
  return LinkColor[color];
}));
LinkChevron.propTypes = linkChevronPropTypes;
LinkChevron.displayName = linkChevronDisplayName;
LinkChevron.defaultProps = linkChevronDefaultProps;
export { LinkUntracked, Link, LinkText, LinkChevron };